// PDF font helper — registers a Unicode TTF (Roboto) with jsPDF once and reuses it.
// This is required for Turkish characters (ç, ğ, ı, İ, ö, ş, ü) to render correctly.

let cachedRegular = null;
let cachedBold = null;

async function fetchToBase64(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Font fetch failed: ${url}`);
  const buf = await res.arrayBuffer();
  // btoa on binary string (chunked to avoid stack overflow for large TTFs)
  const bytes = new Uint8Array(buf);
  let binary = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

async function ensureFonts() {
  if (!cachedRegular) {
    cachedRegular = await fetchToBase64("/fonts/Roboto-Regular.ttf");
  }
  if (!cachedBold) {
    cachedBold = await fetchToBase64("/fonts/Roboto-Bold.ttf");
  }
  return { regular: cachedRegular, bold: cachedBold };
}

/**
 * Registers Roboto with a jsPDF instance and sets it as the default font.
 * Call this AFTER `new jsPDF()` and BEFORE any doc.text() calls.
 * Safe to call multiple times per doc.
 */
export async function registerTurkishFont(doc) {
  const { regular, bold } = await ensureFonts();
  doc.addFileToVFS("Roboto-Regular.ttf", regular);
  doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
  doc.addFileToVFS("Roboto-Bold.ttf", bold);
  doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");
  doc.setFont("Roboto", "normal");
  return doc;
}
